import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getVertexAI, GenerativeModel, getGenerativeModel } from "firebase/vertexai";

// Environment values with multiple fallback strategies
const getEnv = (key: string, defaultValue: string = ""): string => {
  if (typeof import.meta !== "undefined" && import.meta.env) {
    const val = import.meta.env[`VITE_${key}`] || import.meta.env[`NEXT_PUBLIC_${key}`];
    if (val) return val;
  }
  return defaultValue;
};

const firebaseConfig = {
  apiKey: getEnv("FIREBASE_API_KEY", "AIzaSyApBVm0AKItfeC6Eq9r_UO4LkmovBNpYbQ"),
  authDomain: getEnv("FIREBASE_AUTH_DOMAIN", "verveailabs.firebaseapp.com"),
  projectId: getEnv("FIREBASE_PROJECT_ID", "verveailabs"),
  storageBucket: getEnv("FIREBASE_STORAGE_BUCKET", "verveailabs.firebasestorage.app"),
  messagingSenderId: getEnv("FIREBASE_MESSAGING_SENDER_ID", "939708406554"),
  appId: getEnv("FIREBASE_APP_ID", "1:939708406554:web:ffc884454507888586eaa3"),
  measurementId: getEnv("FIREBASE_MEASUREMENT_ID", "G-Q6HHPC80MW"),
};

const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

// Safe initialization of client Vertex AI / Firebase AI Logic
let vertexAiInstance: any = null;
try {
  vertexAiInstance = getVertexAI(app);
} catch (err) {
  console.warn("Firebase Vertex AI initialization warning:", err);
}

export function getGeminiModel(modelName: string = "gemini-3.8-flash", generationConfig?: any): GenerativeModel | null {
  try {
    if (vertexAiInstance) {
      return getGenerativeModel(vertexAiInstance, {
        model: modelName,
        generationConfig
      });
    }
  } catch (err) {
    console.warn("Failed to get Vertex AI generative model:", err);
  }
  return null;
}

export { app, auth, db, storage, firebaseConfig };
